import React from 'react'
import { NotFoundPanelContainer, NotFoundInnerContainer } from './elements'
import { Box } from '@mui/material'
// import HeroForm from '../Form/HeroForm'
import NotFoundContent from "../../components/NotFound/NotFoundContent";

const NotFoundPanel: React.FC = () => {
    return (
        <NotFoundPanelContainer>
            <NotFoundInnerContainer>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <NotFoundContent />
                </Box>
            </NotFoundInnerContainer>
        </NotFoundPanelContainer >
    )
}

export default NotFoundPanel